/*
@since: 2023-8-17
@author: Mohammad Traboulsi
@maintainer: Mohammad Traboulsi
@copyright: AlgoTraders, All rights reserved
*/

export const BASE_BACKEND_URL = "https://dashboard.centrallimit.ai:5001";
// export const BASE_BACKEND_URL = "http://localhost:8000";
// export const BASE_BACKEND_URL = "https://dashboard.centrallimit.ai:5001";

// Feature toggles, keep aligned with the StrategyArchitect_Registration_Enabled
// and StrategyArchitect_Payments_Enabled flags in the backend AlgoSettings hjson
export const REGISTRATION_ENABLED = false;
export const PAYMENTS_ENABLED = false;
